<template>
  <div class="payment-merchant-audit">

    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>支付商编审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 主内容卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 搜索和操作区域 -->
      <div class="search-operation-area">
        <el-form
                :inline="true"
                :model="searchForm"
                ref="searchForRef"
                label-width="100px"
                size="mini"
                class="search-form"
        >
          <el-form-item label="名称">
            <el-input
                    v-model="searchForm.keywords"
                    placeholder="请输入商户号"
                    clearable
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="searchSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属代理商"  >
            <el-input  placeholder="请选择所属代理商" v-model="searchForm.proxy_name" :readonly="true"  @click.native="cProxy" clearable type="text">
              <i slot="suffix" class="el-icon-more"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="searchForm.is_auth" placeholder="请选择审核状态" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="待审" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="拒绝" value="2"></el-option>
              <el-option label="取消" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="operation-buttons">
            <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
            >搜索</el-button>

          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <div class="table-area">
        <el-table
                :data="tableLoadData"
                stripe
                border
                size="mini"
                style="width: 100%"
                v-loading="loading"
                :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
                :row-class-name="tableRowClassName"
                height="calc(100vh - 200px)"
        >
          <el-table-column
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
          >
            <template slot-scope="scope">
              <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="50">
            <template slot-scope="props">
              <div class="expand-content">
                <div class="expand-title">
                  <i class="el-icon-s-data"></i>分成详情
                </div>
                <el-table
                        :data="props.row.balance"
                        size="mini"
                        style="width: 100%"
                >
                  <el-table-column
                          prop="proxy_sn"
                          label="代理编码"
                          align="center"
                  ></el-table-column>
                  <el-table-column
                          prop="name"
                          label="姓名"
                          align="center"
                  ></el-table-column>
                  <el-table-column
                          prop="bank_name"
                          label="银行"
                          align="center"
                  ></el-table-column>
                  <el-table-column
                          prop="rate"
                          label="比例(%)"
                          align="center"
                          width="100"
                  >
                    <template slot-scope="{row}">
                      <el-tag :type="getRateType(row.rate)" size="mini">
                        {{ row.rate }}%
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="bank_card"
                          label="卡号"
                          align="center"
                          width="120"
                  >
                    <template slot-scope="{row}">
                      <el-tooltip :content="row.bank_card" placement="top">
                        <span>{{ formatBankCard(row.bank_card) }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                </el-table>
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  prop="cusid"
                  label="商户编号"
                  width="120"
                  align="center"
          ></el-table-column>

          <el-table-column
                  label="所属通道"
                  width="120"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.source" type="info">
                {{ scope.row.source.name }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="所属代理"
                  width="140"
                  align="center"
          >
            <template slot-scope="scope">
              <div class="proxy-info">
<!--                <el-avatar-->
<!--                        v-if="scope.row.proxy"-->
<!--                        size="small"-->
<!--                        :src="scope.row.proxy.avatar || ''"-->
<!--                        style="margin-right: 8px"-->
<!--                ></el-avatar>-->
                <span>{{ scope.row.proxy ? scope.row.proxy.real_name : '-' }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  label="通道比例"
                  width="100"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" size="small">
                {{ scope.row.source_rate }}%
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="税点比例"
                  width="100"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag type="danger" size="small">
                {{ scope.row.plat_rate }}%
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="营收比例"
                  width="100"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag  size="small">
                {{ scope.row.revenue_rate }}%
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="状态"
                  width="90"
                  align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      :type="getStatusType(scope.row.is_auth)"
                      effect="dark"
                      size="mini"
              >
                {{ getStatusText(scope.row.is_auth) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
                  label="备注"
                  width="100"
                  align="center"
          >
            <template slot-scope="scope">
                {{ scope.row.remark }}
            </template>
          </el-table-column>
          <el-table-column
                  label="创建时间"
                  width="160"
                  align="center"
          >
            <template slot-scope="scope">
              <div class="time-cell">
                <i class="el-icon-time"></i>
                {{ formatTime(scope.row.add_time) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  label="操作"
                  width="200"
                  fixed="right"
                  align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                        type="primary"
                        icon="el-icon-view"
                        size="mini"
                        @click="goDetail(scope.row)"
                        title="详情"
                ></el-button>

                <el-button
                        type="warning"
                        icon="el-icon-edit"
                        size="mini"
                        @click="goAuth(scope.row)"

                        title="审核"
                ></el-button>
                <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="mini"
                        @click="handleDel(scope.row)"
                        title="删除"
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-area">
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
        ></el-pagination>
      </div>
    </el-card>

    <!-- 审核抽屉 -->
    <el-drawer
            title="支付商编审核"
            :visible.sync="drawer"
            :direction="direction"
            size="40%"
            :before-close="handleDrawerClose"
    >
      <div class="drawer-content">
        <el-form
                :model="dataForm"
                ref="dateFormRef"
                label-width="100px"
                size="mini"
                class="audit-form"
        >
          <!-- 分成详情 -->
          <el-form-item label="分成详情">
            <div class="balance-table">
              <el-table
                      :data="balanceList"
                      border
                      size="mini"
                      style="width: 100%"
              >
                <el-table-column
                        prop="proxy_sn"
                        label="代理编码"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="name"
                        label="姓名"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="bank_name"
                        label="银行"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="bank_card"
                        label="卡号"
                        align="center"
                >
                  <template slot-scope="{row}">
                    <el-tag type="info" size="mini">
                      {{ formatBankCard(row.bank_card) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="rate"
                        label="比例"
                        align="center"
                >
                  <template slot-scope="{row}">
                    <el-progress
                            :percentage="Number(row.rate)"
                            :show-text="false"
                            :color="customColors"
                    ></el-progress>
                    <span style="font-size: 12px">{{ row.rate }}%</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>

          <el-divider></el-divider>

          <!-- 审核信息 -->
          <div class="audit-info">
            <el-form-item label="商户编号" >
              <el-input
                      v-model="dataForm.cusid"

                      suffix-icon="el-icon-document"
              ></el-input>
            </el-form-item>

            <el-form-item label="所属通道">
              <el-input
                      v-model="dataForm.source_name"
                      readonly
                      suffix-icon="el-icon-connection"
              ></el-input>
            </el-form-item>

            <el-form-item label="通道比例">
              <el-input
                      v-model="dataForm.source_rate"
                      type="number"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>

            <el-form-item label="税点比例">
              <el-input
                      v-model="dataForm.plat_rate"
                      type="number"
                      placeholder="请输入税点比例"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="营收比例">
              <el-input
                      v-model="dataForm.revenue_rate"
                      type="number"
                      placeholder="请输入营收比例"
              >
                <template slot="append">%</template>
              </el-input>
              -  <el-input
                    v-model="dataForm.revenue_fee_rate"
                    type="number"
                    placeholder="请输入营收费率"
            >
              <template slot="append">%</template>
            </el-input>
            </el-form-item>
           <el-form-item label="状态">
             <el-tag
                     :type="getStatusType(dataForm.is_auth)"
                     effect="dark"
                     size="mini"
             >
               {{ getStatusText(dataForm.is_auth) }}
             </el-tag>
           </el-form-item>
            <el-form-item label="审核意见">
              <el-input
                      v-model="dataForm.auth_remark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入审核意见（可选）"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 操作按钮 -->
          <div class="drawer-footer">
            <el-button   size="mini" @click="handleDrawerClose">取 消</el-button>
            <el-button
                    size="mini"
                    type="success"
                    icon="el-icon-check"
                    @click="handleApprove"

            >通 过</el-button>
            <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-close"
                    @click="handleReject"

            >拒 绝</el-button>
<!--            <el-button-->
<!--                    size="mini"-->
<!--                    type="primary"-->
<!--                    icon="el-icon-check"-->
<!--                    @click="handleSave"-->
<!--               -->
<!--            >保 存</el-button>-->
          </div>
        </el-form>
      </div>
    </el-drawer>

    <!-- 详情对话框 -->
    <el-dialog
            :title="detailTitle"
            :visible.sync="detailDialogVisible"
            width="600px"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item label="商户编号">{{ currentRow.cusid }}</el-descriptions-item>
        <el-descriptions-item label="通道名称">{{ currentRow.source?.name }}</el-descriptions-item>
        <el-descriptions-item label="代理姓名">{{ currentRow.proxy?.real_name }}</el-descriptions-item>
        <el-descriptions-item label="通道比例">{{ currentRow.source_rate }}%</el-descriptions-item>
        <el-descriptions-item label="平台比例">{{ currentRow.plat_rate }}%</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(currentRow.is_auth)">
            {{ getStatusText(currentRow.is_auth) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(currentRow.add_time) }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import eProxyList from "../common/eProxyList"
  export default {
    name: "posSourceParamsAuthList",
    components: { eProxyList},
    data() {
      return {
        formData2:{pid:''},
        title2:'',
        visible2:false,
        loading: false,
        customColors: [
          { color: '#f56c6c', percentage: 20 },
          { color: '#e6a23c', percentage: 40 },
          { color: '#5cb87a', percentage: 60 },
          { color: '#1989fa', percentage: 80 },
          { color: '#6f7ad3', percentage: 100 }
        ],
        balanceList: [],
        dataForm: {
          id: '',
          name: '',
          cusid: '',
          source_name: '',
          plat_rate: 0,
          source_rate: 0,
          revenue_rate:0,
          auth_remark: '',
          is_auth: 0
        },
        drawer: false,
        direction: 'rtl',
        detailDialogVisible: false,
        currentRow: {},
        detailTitle: '商户详情',
        searchForm: {
          keywords: "",
          proxy_name:'',
          proxy_id:'',
          is_auth:''
        },
        tableLoadData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showType: '',
      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList();
    },
    methods: {
      chooseProxy(id,...params){
        this.searchForm.proxy_id=id;
        this.searchForm.proxy_name=params[0];
      },
      cProxy(){
        this.title2="选择所属代理";
        this.visible2=true;

      },
      closeForm2(){
        this.visible2=false;
      },
      // 格式化银行卡号
      formatBankCard(card) {
        if (!card) return '';
        return card.replace(/(\d{4})(?=\d)/g, '$1 ');
      },

      // 格式化时间
      formatTime(timestamp) {
        if (!timestamp) return '';
        return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
      },

      // 获取状态类型
      getStatusType(is_auth) {
        const map = {
          0: 'warning',  // 待审
          1: 'success',  // 正常
          2: 'danger'    // 拒绝
        };
        return map[is_auth] || 'info';
      },

      // 获取状态文本
      getStatusText(is_auth) {
        const map = {
          0: '待审核',
          1: '正常',
          2: '已拒绝'
        };
        return map[is_auth] || '未知';
      },

      // 获取比例类型
      getRateType(rate) {
        if (rate >= 50) return 'danger';
        if (rate >= 30) return 'warning';
        return 'success';
      },

      // 表格行样式
      tableRowClassName({ row }) {
        if (row.is_auth === 0) return 'warning-row';
        if (row.is_auth === 2) return 'danger-row';
        return '';
      },

      handleDrawerClose() {
        this.drawer = false;
        this.resetDataForm();
      },

      goDetail(row) {
        this.currentRow = row;
        this.detailTitle = `商户详情 - ${row.cusid}`;
        this.detailDialogVisible = true;
      },

      goAuth(row) {
        this.dataForm = {
          ...row,
          source_name: row.source?.name || '',
          auth_remark: ''
        };
        this.balanceList = row.balance || [];
        this.drawer = true;
      },

      DataList() {
        this.loading = true;
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          showType: this.showType,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm
        };
        this.$axios.findPaySourceParamsBalanceListP(param).then(res => {
          if (res.code == 200) {
            this.tableLoadData = res.data.data;
            this.total = res.data.total;
          }
        }).catch(error => {
          console.log(error);
          this.$message.error('数据加载失败');
        }).finally(() => {
          this.loading = false;
        });
      },

      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.DataList();
      },

      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.DataList();
      },

      searchSubmit() {
        this.pageNum = 1;
        this.DataList();
      },

      addData() {
        this.$router.push('/payMerForm');
      },

      resetDataForm() {
        this.dataForm = {
          id: '',
          name: '',
          cusid: '',
          source_name: '',
          plat_rate: 0,
          source_rate: 0,
          revenue_rate:0,
          auth_remark: '',
          is_auth: 0
        };
        this.balanceList = [];
      },

      handleApprove() {
        // 审核通过逻辑
        this.$confirm('确定通过该商户的审核吗？', '审核确认', {
          type: 'success',
          confirmButtonText: '确定通过',
          cancelButtonText: '取消'
        }).then(() => {

          let param={
            id:this.dataForm.id,
            is_auth:1,
            auth_remark:this.dataForm.auth_remark,
            cusid:this.dataForm.cusid,
            plat_rate: this.dataForm.plat_rate,
            source_rate: this.dataForm.source_rate,
            revenue_rate:this.dataForm.revenue_rate,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          }
          this.$axios.paySourceParamsAuth(param).then(res=>{
            if(res.code==200){
              this.$message.success('审核通过成功');
              this.drawer = false;
              this.DataList();
            }else{
              this.$message.error(res.msg);
              this.drawer = false;
              this.DataList();
            }
          })

        }).catch(()=>{

        });
      },
      handleDel(row) {

        // 审核通过逻辑
        this.$confirm('确定删除该商户的审核吗？', '删除确认', {
          type: 'warning',
          confirmButtonText: '确定删除',
          cancelButtonText: '取消'
        }).then(() => {
          let param={
            id:row.id,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          }
          this.$axios.paySourceParamsDel(param).then(res=>{
            if(res.code==200){
              this.$message.success('删除成功');
              this.drawer = false;
              this.DataList();
            }else{
              this.$message.error(res.msg);
              this.drawer = false;
              this.DataList();
            }
          })

        }).catch(()=>{

        });
      },

      handleReject() {
        // 审核拒绝逻辑
        this.$confirm('确定拒绝该商户的审核吗？', '审核确认', {
          type: 'warning',
          confirmButtonText: '确定拒绝',
          cancelButtonText: '取消'
        }).then(() => {
          let param={
            id:this.dataForm.id,
            is_auth:2,
            plat_rate: this.dataForm.plat_rate,
            source_rate: this.dataForm.source_rate,
            auth_remark:this.dataForm.auth_remark,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          }
          this.$axios.paySourceParamsAuth(param).then(res=>{
            if(res.code==200){
              this.$message.success('审核通过成功');
              this.drawer = false;
              this.DataList();
            }else{
              this.$message.error(res.msg);
              this.drawer = false;
              this.DataList();
            }
          })
          this.drawer = false;
          this.DataList();
        }).catch(()=>{

        });
      },

      handleSave() {
        // 保存逻辑
        this.$message.success('保存成功');
        this.drawer = false;
        this.DataList();
      },

      showMoreActions(row) {
        this.$message.info(`更多操作: ${row.cusid}`);
      }
    }
  };
</script>

<style lang="scss" scoped>

  .breadcrumb-container {
    margin-bottom: 20px;
  }

  .breadcrumb-container .el-breadcrumb {
    font-size: 14px;
  }

  .payment-merchant-audit {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);

    .breadcrumb-wrapper {
      margin-bottom: 20px;
      padding: 15px;
      background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
      border-radius: 8px;

      ::v-deep .el-breadcrumb {
        .el-breadcrumb__item {
          &:last-child .el-breadcrumb__inner {
            color: #ffffff;
            font-weight: bold;
          }

          .el-breadcrumb__inner {
            color: rgba(255, 255, 255, 0.9);

            &:hover {
              color: #ffffff;
            }
          }
        }
      }
    }

    .main-card {
      border-radius: 12px;
      border: 1px solid #ebeef5;

      .search-operation-area {
        margin-bottom: 20px;

        .search-form {
          display: flex;
          align-items: center;

          ::v-deep .el-form-item {
            margin-bottom: 0;
          }

          .operation-buttons {
            margin-left: auto;

            .el-button {
              border-radius: 6px;
              font-weight: 500;
              padding: 10px 20px;

              &:first-child {
                margin-right: 10px;
              }
            }
          }
        }
      }

      .table-area {
        ::v-deep .el-table {
          border-radius: 8px;
          overflow: hidden;

          th {
            font-weight: 600;
            background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
            color: #666;
          }

          .warning-row {
            background: #fdf6ec;
          }

          .danger-row {
            background: #fef0f0;
          }

          .expand-content {
            padding: 20px;
            background: #f8f9fa;
            border-radius: 8px;

            .expand-title {
              margin-bottom: 15px;
              color: #606266;
              font-weight: 600;
              font-size: 14px;

              i {
                margin-right: 8px;
                color: #409eff;
              }
            }
          }

          .proxy-info {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .time-cell {
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              margin-right: 5px;
              color: #909399;
            }
          }
        }
      }

      .pagination-area {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;

        ::v-deep .el-pagination {
          .el-pager li {
            border-radius: 4px;

            &.active {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: #ffffff;
            }
          }
        }
      }
    }

    .drawer-content {
      padding: 20px;

      .audit-form {
        .balance-table {
          max-height: 300px;
          overflow-y: auto;
          padding: 10px;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .audit-info {
          margin-top: 20px;
        }

        .drawer-footer {
          margin-top: 30px;
          text-align: right;

          .el-button {
            margin-left: 10px;
            min-width: 100px;
          }
        }
      }
    }
  }

  // 全局覆盖
  ::v-deep .el-table__expanded-cell {
    background: #f8f9fa;
    padding: 20px !important;
  }

  ::v-deep .el-drawer {
    .el-drawer__header {
      margin-bottom: 20px;
      padding: 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
</style>
